export default __webpack_public_path__ + "static/tara-ss-b19a299546fdcf0f43e2762ea5c8624d.png";